import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../_service/leads.service';
import { SharedService } from '../_service/shared.service';
import { MiscService } from '../_service/misc.service';
import { ActivatedRoute, Router  } from '@angular/router';
import Handsontable from 'handsontable';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UpdateInsuranceModalComponent} from '../insurance/update-insurance-modal/update-insurance-modal.component';
import {UpdatePreauthModalComponent} from '../insurance/update-preauth-modal/update-preauth-modal.component';
import{ GlobalConstants } from '../common/global-constants';
import {OpdModalComponent} from '../opd/opd-modal/opd-modal.component';
import {IpdModalComponent} from '../ipd/ipd-modal/ipd-modal.component';
import {FollowDnpModalComponent} from '../lead_section/follow-dnp-modal/follow-dnp-modal.component';
import { FollowDnpDetailModalComponent } from '../lead_section/follow-dnp-detail-modal/follow-dnp-detail-modal.component';
import { CrossBdComponent } from '../lead_section/cross-bd/cross-bd.component';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
import { AddLabLeadModalComponent } from '../lab_section/add-lab-lead-modal/add-lab-lead-modal.component';
declare var $: any;

@Component({
  selector: 'app-glamyohealth-partners',
  templateUrl: './glamyohealth-partners.component.html',
  styleUrls: ['./glamyohealth-partners.component.css']
})
export class GlamyohealthPartnersComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  @ViewChild('followupdateRangeStart', {static: false}) followupdateRangeStart: ElementRef;
  @ViewChild('followupdateRangeEnd', {static: false}) followupdateRangeEnd: ElementRef;

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  leads:any=[];private hotRegisterer = new HotTableRegisterer();alltreatments=[];treatments=[];leadStatus=[];circles=[];userId:string;
  id = 'hotInstance'; settings = {colHeaders: true };bds=[];paymentOpt=[];leadallStatus=[];allbds=[];treatment='';ActionOpt=[];hideColumn:any;gender=[];treatment_modal='';
  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;roleStatus=false;circle='';sheetCircle=[];
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;myrole:string;submitted = false;adminRole:boolean=true; qaRole:boolean=false;
  search:string;lead_source:any;lead_status:string;bd:string;start_date:string='';end_date:string='';width=200;followupadte:string;leadClickId;
  showInsurance:string;leadStatus_copy=[];bds_copy=[];circles_copy=[];treatments_copy=[];showopdDonebutIpdNotDone:string;bridgeno;copyData:boolean= false;LeadId;
  datanew=[];category_filter:string;payment_mode:string;leadDnpFollowDetail:any;Checkdnpmodal:boolean=true; dnpFollowupmodalcheck:boolean=false;lead_category_filter='';link_share_filter='';treatCategory=[];tertiary_city_filter:string;isCMAccess:string;
  tertiarycityFilter:boolean=false;treatmentCategoryAccess:string;
  displayInactiveUsersLead:boolean;lead_sources=[];bridge_number_lists=[];start_date_follow_up:string='';end_date_follow_up:string='';updatedLodData=[];history_loading:boolean=true;history_loaded:boolean=false;cross_bd_lead_id = '';
  click_to_call_loading:boolean=false;response_call_id='';progression_msg='';
  end_to_call_btn_disable=false;  shareApp_loading:boolean=false;bds_list=[];


  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,public miscapi:MiscService,private router: Router)
  {
      //this.getbds();
      this.sharedapi.getRole()
      .subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      this.isCMAccess = localStorage.getItem('CMAccess');
      if(this.myrole=='2' || this.myrole=='15')
      {
          this.roleStatus = true;
      }else if(this.myrole=='1')
      {
          this.adminRole = false;
      }
      if(this.myrole=='15' || this.myrole=='1'){
          this.qaRole = true;
      }

      this.treatmentCategoryAccess = localStorage.getItem('treatment_catergory_access');

      this.paymentOpt = ['Cash','Cashless','Reimbursement','EMI','Cheque','Razorpay','Net Banking'];
      
      this.ActionOpt = ['Select','Upload Insurance Card','Send Preauth Request','Post OPD','Post IPD','Create Duplicate Lead','Book Scan','Book Lab Test'];
      // for making Action menu options //
      if(this.myrole=='2' || this.myrole=='3'){
          this.ActionOpt = ['Select','Book Scan','Create Duplicate Lead','Book Lab Test'];
          this.paymentOpt = ['Cash','EMI','Cheque','Razorpay','Net Banking'];
          if(this.treatmentCategoryAccess=='2' || this.treatmentCategoryAccess=='3'){
              this.ActionOpt = ['Select','Upload Insurance Card','Send Preauth Request','Post OPD','Post IPD','Create Duplicate Lead','Book Lab Test'];  
              this.paymentOpt = ['Cash','Cashless','Reimbursement','EMI'];
          }
      }
      this.gender=['Male','Female'];
      this.userId = localStorage.getItem('loginuserId');
      /* console.log(this.userId); */

      this.getbds();this.getcircle();this.getLeadSources();this.getBridgeNumberLists();
      this.getleadStatus();this.getTreatment();this.getTreatmentCategory();
      this.loadCommonData();


  }

  selectAll(select: NgModel) {
      let values: any[] = []; // array which will contain all values
      // loop through all groups and add their items' values to the array
      for(let group of this.allbds){
        values.push(group.id);
      }
      let data = values.map(x=>`${x}`).toString().split(',');
      select.update.emit(data);
      this.loadleads(0,this.perpage);

    }
  
    deselectAll(select: NgModel) {
      select.update.emit([]);
      this.loadleads(0,this.perpage);
    }

  ngOnInit(): void {
      
  }
  ngAfterViewInit() {
      this.loadleads(0,25);
  }

  openDnpFollowupDetailDialog(leadId)
  {
      const dialogRef = this.dialog.open(FollowDnpDetailModalComponent, {
          width: '50%',height: '70%',
          data:{leadId:leadId}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openleadHistoryPopup(leadIId)
  {
      this.history_loading = true;this.history_loaded = false;
      this.leadapi.getFullLeadHistory(leadIId).subscribe((data:any) => {
          this.history_loading = false;
          this.history_loaded = true;
          if(data.status)
          {
              this.updatedLodData = data.data;
          }else{
              this.updatedLodData = [];
              /* this.sharedapi.presentToast(data.msg); */
          }
      }, error => {
              this.sharedapi.checkError(error);
      });
      $('#myHistoryModal').modal();
  }

  closeHistoryPopup()
  {
      $('#myHistoryModal').modal('hide');
  }

  afterOnCellMouseDownCallBack = (event, coords, TD) =>
  {
      if(event.target.nodeName.toLowerCase() == 'a'){
          let leadIId = event.target.attributes.id.nodeValue;
          this.openleadHistoryPopup(leadIId);
      }
      if(event.target.className == 'send_applink')
      {
          let leadId = event.target.attributes.id.nodeValue;
          this.shareAppLink(leadId);
          
      }
      
  }

  shareAppLink(lead_id){
      console.log('shareapp')
        this.shareApp_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.leadapi.share_app_link(lead_id_arr).subscribe((data:any) => {
            this.shareApp_loading = false;
            console.log(data);
            if(data.status){
                this.sharedapi.presentToast(data.msg);
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        }); 
  }

  click_to_call_function(lead_id)
  {
      this.click_to_call_loading = true;
      let lead_id_arr = {'lead_id': lead_id};
      this.leadapi.clickTOCall(lead_id_arr).subscribe((data:any) => {
          this.click_to_call_loading = false;
          console.log(data);
          if(data.status){
              this.response_call_id = data.call_id;
              $("#click_to_call_progress").modal("show");
          } else {
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  endClicktoCall()
  {
      this.progression_msg = "";
      this.end_to_call_btn_disable = true;
      if(this.response_call_id)
      {
          let lead_id_arr = {'response_call_id': this.response_call_id};
          this.leadapi.endClicktoCall(lead_id_arr).subscribe((data:any) => {
              this.end_to_call_btn_disable = false;
              $('#click_to_call_progress').modal('hide');
              // if(data.status){
              //     if(data.data.data.length > 0) {
              //         if(data.data.data[0].duration > 0) {
              //             this.response_call_id = '';
              //             $('#click_to_call_progress').modal('hide');
              //             this.loadleads(0,this.perpage);
              //         } else {
              //             this.progression_msg = "Please cut the call from mobile first, then click on end call here.";
              //         }
              //     } else {
              //         this.progression_msg = "Phone is ringing, You cannot end the call yet. If you remove popup, can reload the page.";
              //     }
              // } else {
              //     this.sharedapi.presentToast(data.msg);
              // }
          }, error => {
              this.sharedapi.checkError(error);
          });
      } else {
          this.sharedapi.checkError("Please reload the page. Something went to wrong.");
      }
      
  }


  setSearchValue(type){
      if(type=='lead_status'){
          $("#lead_status_Search").val('');
          $("#lead_status_Search").focus();
          this.leadallStatus= this.leadStatus_copy;
      }else if(type=='bds'){
          $("#bd_search").val('');
          $("#bd_search").focus();
          this.allbds= this.bds_copy;
      }else if(type=='circle'){
          $("#circleSearch").val('');
          $("#circleSearch").focus();
          this.circles= this.circles_copy;
      }else if(type=='treatment'){
          $("#treatmentSearch").val('');
          $("#treatmentSearch").focus();
          this.alltreatments= this.treatments_copy;
      }else if(type=='treatment_modal'){
          $("#treatmentModalSearch").val('');
          $("#treatmentModalSearch").focus();
          this.alltreatments= this.treatments_copy;
      }
  }

  searchOnSelect(searchtText: string, type){
      if (type == 'lead_status') {
          this.leadallStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
      }else if(type == 'bds'){
          this.allbds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
      }else  if (type == 'circle') {
          this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
      }else  if (type == 'treatment') {
          this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
      }else  if (type == 'treatment_modal') {
          this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
      }
  }

  async loadleads(pageIndex,perpage)
  {
      this.tertiarycityFilter = false;
      if(this.circle.indexOf('8') !== -1){
          this.tertiarycityFilter = true;
      }
      if(this.displayInactiveUsersLead == true) {
        this.getbds(0);
      } else {
        this.getbds();
      }
      this.leads = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      
      
      let lead_type = "";
      if(this.router.url == "/partner-lead-sheetview"){
          lead_type = "partner";
      }

      //let qString = 'insurance='+this.showInsurance+'&search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&followupdate='+this.followupadte+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&lead_type='+lead_type;
      let qString = 'search='+this.search+'&lead_source='+this.lead_source+'&lead_status='+this.lead_status+'&link_share_opt='+this.link_share_filter+'&date_range='+this.start_date+'-'+this.end_date+'&bd='+this.bd;

      this.loading = true;this.loaded = false;
      this.leadapi.getGlamyoHealthPartnersLeadsSheet(pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.leads = data.data;
              if(this.userId=='16'){
                  this.hideColumn = {columns: [4],indicators: true};
              }

          }else{
              this.leads = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  async saveDetails()
  {
      this.submitted = true;
     let data= this.hotRegisterer.getInstance(this.id).getSourceData();
     let alldata = {'data':data};
     if(data.length>0)
     {
          await this.leadapi.updateSheetData(alldata).subscribe((data:any) => {
              this.submitted = false;
              if(data.status)
              {
                  this.sharedapi.presentToast(data.msg);
              }else{
                  this.sharedapi.presentToast(data.msg);
              }
          }, error => {
               this.sharedapi.checkError(error);
          });
      }
  }

  async loadCommonData()
  {
      await this.leadapi.getCommonData().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.treatment;
              /* console.log(this.treatments); */
              this.bds = data.insuranceBds;
              this.leadStatus = data.lead_status;
              this.sheetCircle = data.circle;
          }else{
              this.leadStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  pageChange(event)
  {
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  async getleadStatus()
  {
      await this.leadapi.getLeadStatus().subscribe((data:any) => {
          if(data.status)
          {
              this.leadallStatus = data.data;
              this.leadStatus_copy = this.leadallStatus;
          }else{
              this.leadallStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getbds(status=1)
  {
      await this.leadapi.getbdsForGlamyoPartners(status).subscribe((data:any) => {
          if(data.status)
          {
              this.allbds = data.data;
              this.bds_copy = this.allbds;
          }else{
              this.allbds = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatment()
  {
      await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.alltreatments = data.data;
              this.treatments_copy = this.alltreatments;
          }else{
              this.alltreatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }
  async getTreatmentCategory()
  {
      await this.miscapi.getTreat_Category().subscribe((data:any) => {
          if(data.status)
          {
              this.treatCategory = data.data;
          }else{
              this.treatCategory = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
              this.circles_copy = this.circles;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getBridgeNumberLists()
  {
      this.leadapi.getBridgeNumberLists().subscribe((data:any) => {
          if(data.status)
          {
              this.bridge_number_lists = data.data;
          }else{
              this.bridge_number_lists = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getLeadSources()
  {
      /* this.leadapi.getLeadSources().subscribe((data:any) => {
          if(data.status)
          {
              this.lead_sources = data.data;
          }else{
              this.lead_sources = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      }); */
      let uri = '';
      if(this.router.url == "/partner-lead-sheetview"){
          uri = "partner_lead";
      } else {
          uri = "none";
      }

      this.leadapi.getUpdatedLeadSources(uri).subscribe((data:any) => {
          if(data.status)
          {
              this.lead_sources = data.data;
          }else{
              this.lead_sources = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          //this.loadleads(0,this.perpage);
      }
  }

  dateRangeChangefollowUp(date1,date2)
  {
      if(date2.value)
      {
          this.start_date_follow_up = date1.value;
          this.end_date_follow_up = date2.value;
          this.loadleads(0,this.perpage);
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadleads(0,this.perpage);
  }

  clearDateFollowUp()
  {
      this.followupdateRangeStart.nativeElement.value = "";
      this.followupdateRangeEnd.nativeElement.value = "";
      this.start_date_follow_up = '';
      this.end_date_follow_up = '';
      this.loadleads(0,this.perpage);
  }

  onBeforeChange = (hotInstance, changes) =>
  {
      let data= this.hotRegisterer.getInstance(this.id).getSourceData();
      let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3],index:hotInstance[0][0]};
      this.saveOnChange(saveData);
  }


  getPaymentTreatmentStatus(saveData){
      this.leadapi.getpaymenttreatmentStatus(saveData.id).subscribe((data:any) => {
          if(data.status)
          {
              if(data.result.status==true){ // If payment mode and treatment updated
                  if(saveData.new_value=='Upload Insurance Card'){
                      if(data.result.data.modePayment=="Cashless" || data.result.data.modePayment=="Reimbursement"){
                          this.openInsuranceDialog(saveData.id);
                      }else{
                          $("#paymentModeErrorModal").modal();
                          $("#PaymentModeErrorMessage").text('Your payment mode is not cashless or Reimbursement. Please select different payment mode.');
                      }

                  } else if (saveData.new_value=='Send Preauth Request') {
                      if(data.result.data.modePayment=="Cashless" || data.result.data.modePayment=="Reimbursement"){
                          if(data.result.data.upload_preauth_status > 0) {
                              this.openPreAuthDialog(saveData.id);
                          } else  {
                              $("#paymentModeErrorModal").modal();
                              $("#PaymentModeErrorMessage").text('Your insurance details has not been approved or preauth files has been already uploaded for this lead.');
                          }
                      }else{
                          $("#paymentModeErrorModal").modal();
                          $("#PaymentModeErrorMessage").text('Your payment mode is not cashless or Reimbursement. Please select different payment mode.');
                      }
                  }
                  else if(saveData.new_value=='Post OPD'){
                      this.openOpdDialog(saveData.id);
                  }
                  else if(saveData.new_value=='Post IPD'){
                      this.openIpdDialog(saveData.id);
                  }
                  else if(saveData.new_value=='Create Duplicate Lead'){
                      this.showDuplicateModal(saveData.id);
                  }
                  else if(saveData.new_value=='Book Scan'){
                      const url = this.router.serializeUrl(
                        this.router.createUrlTree(['/book-scan/' + saveData.id])
                      );
                      window.open(url, '_blank');
                  }
                  else if(saveData.new_value=='Book Lab Test'){
                      this.openBookLabTestDialog(saveData.id);
                  }
                  //for check dnp-followup modal //
                  else if(saveData.field_name=='lead_status_name'){
                     if(saveData.new_value=='DNP-1' || saveData.new_value=='DNP-2' || saveData.new_value=='DNP-3' || saveData.new_value=='DNP-4' || saveData.new_value=='DNP-5' || saveData.new_value=='Follow Up-1' || saveData.new_value=='Follow Up-2' || saveData.new_value=='Follow Up-3'){
                          // check for dnp follow up data exits or not //
                          this.checkDnpFollowUpDataExists(saveData);
                      }else{
                          this.updateSingleData(saveData);
                      }
                  }
              }else{ // If payment mode and treatment not updated
                  if(saveData.field_name=='lead_status_name' && (saveData.new_value=='DNP-1' || saveData.new_value=='DNP-2' || saveData.new_value=='DNP-3' || saveData.new_value=='DNP-4' || saveData.new_value=='DNP-5' || saveData.new_value=='Follow Up-1' || saveData.new_value=='Follow Up-2' || saveData.new_value=='Follow Up-3')){
                     // check for dnp follow up data exits or not //
                     this.checkDnpFollowUpDataExists(saveData);
                  }
                  else if(saveData.field_name=='lead_status_name' && (saveData.new_value=='Cross BD' || saveData.new_value=='Dnp Exhausted' || saveData.new_value=='Covid' || saveData.new_value=='New Lead' || saveData.new_value=='Junk Lead' || saveData.new_value=='Out of city' || saveData.new_value=='Supply Gap')){
                      this.updateSingleData(saveData);
                  }
                  else{
                      this.openDnpFollowModal(saveData.id,saveData.new_value,saveData, data.result);
                      this.Checkdnpmodal=true;
                  }
              }
          }
      })
  }

  checkDnpFollowUpDataExists(saveData){
      let pagetype=3;
      if(saveData.new_value.includes('DNP')){
          pagetype=1;
      } else if(saveData.new_value.includes('Follow')) {
         pagetype=2;
      }
      this.leadapi.checkDnpFollowUpDataExist(saveData.id,saveData.new_value,pagetype).subscribe((data:any) =>
      {
          if(data.status){
              if(data.data > 0){
                  if(this.Checkdnpmodal==true && (data.result.data.display_followup==1 || (pagetype == 2 && (data.result.data.paymentMode==0 || data.result.data.treatment==0)))){
                      this.openDnpFollowModal(saveData.id,saveData.new_value,saveData,data.result);
                      this.Checkdnpmodal=false;
                  } else {
                    this.updateSingleData(saveData);
                    // Insert record into followup dnp table when direct follow up date change..
                    var dnpFollowupFormData: any = new FormData();
                    dnpFollowupFormData.append('lead_id', saveData.id);
                    dnpFollowupFormData.append('pagetype', pagetype);
                    dnpFollowupFormData.append('type', saveData.new_value);
                    dnpFollowupFormData.append('dnp_followup_date', data.result.data.followUpDate);
                    dnpFollowupFormData.append('fieldName', saveData.field_name);
                    dnpFollowupFormData.append('comments', data.result.data.description);

                    this.leadapi.addDnpFollowUpData(dnpFollowupFormData).subscribe((data:any) => {}, error =>
                    {
                      this.sharedapi.checkError(error);
                    });

                  }
              }else{
                if(data.msg_type =='Toast'){
                  this.sharedapi.presentToast(data.message);
                } else {
                  // modal for when prevoius data not entered//
                  $("#previousdnpfollowModal").modal();
                  $("#ActionTextMessage").text(data.message);
                  // in case of re-ording of column need to update setDataAtCell value
                  const alldata= this.hotRegisterer.getInstance(this.id);
                  alldata.setDataAtCell(saveData.index,GlobalConstants.sheetColumns.status,saveData.old_value);
                  this.Checkdnpmodal=false;
                }
              }
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async saveOnChange(saveData)
  {
    this.updateSingleData(saveData);
  }
  updateSingleData(saveData){
    if(!saveData.old_value){
        saveData.old_value = '';
    } 
    this.submitted = true;
    this.leadapi.updateSingleDataInsuranceBd(saveData).subscribe((data:any) =>
    {
        this.submitted = false;
        this.sharedapi.presentToast(data.msg);
       
    }, error => {
        this.sharedapi.checkError(error);
    });
      
  }

  open_cross_bd_modal(saveData)
  {
      const dialogRef = this.dialog.open(CrossBdComponent, {
          width: '50%',height: '50%',
          data:{cross_bd_lead_id:this.cross_bd_lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          this.loadleads(0,this.perpage);
      });
  }


  openDnpFollowModal(leadId,type,saveData, currentData)
  {
    let pagetype=3;
    if(saveData.new_value.includes('DNP')){
        pagetype=1;
    } else if(saveData.new_value.includes('Follow')) {
       pagetype=2;
    }
      let fieldName = saveData.field_name;
      const dialogRef = this.dialog.open(FollowDnpModalComponent, {
          width: '40%',height: '350px',
          data:{leadId,pagetype,type,currentData,fieldName}
      });

      dialogRef.afterClosed().subscribe(result => {
          if(result){
              if(result.event=='Cancel' && saveData.field_name =='lead_status_name'){
                  // in case of re-ording of column need to update setDataAtCell value
                  const alldata= this.hotRegisterer.getInstance(this.id);
                  alldata.setDataAtCell(saveData.index,GlobalConstants.sheetColumns.status,saveData.old_value);
                  this.Checkdnpmodal=false;
              }
          }
      });
  }

  showDuplicateModal(leadid){
      this.LeadId= leadid;
      $('#duplicateModal').modal();
  }

  hideduplicateModal()
  {
      $('#duplicateModal').modal('hide');
  }
  hideStatusModal(type)
  {
      if(type==1){
          $('#paymentTreatmentModal').modal('hide');
      }else if(type==2){
          $('#previousdnpfollowModal').modal('hide');
      }else{
          $('#paymentModeErrorModal').modal('hide');
      }
  }
  hide_cross_bd_modal()
  {
      $('#cross_bd_modal').modal('hide');
  }


  copyLead(){
      this.copyData=true;
      this.leadapi.copyLeadData(this.LeadId).subscribe((data:any) => {
          if(data.status)
          {
              this.copyData=false;
              $('#duplicateModal').modal('hide');
              this.loadleads(0,this.perpage);
          }
      }, error => {
          this.copyData=false;
          this.sharedapi.checkError(error);
      });
  }

  openInsuranceDialog(lead_id)
  {
      const dialogRef = this.dialog.open(UpdateInsuranceModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openOpdDialog(lead_id)
  {
      const dialogRef = this.dialog.open(OpdModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openIpdDialog(lead_id)
  {
      const dialogRef = this.dialog.open(IpdModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openBookLabTestDialog(lead_id)
  {
      const dialogRef = this.dialog.open(AddLabLeadModalComponent, {
          width: '100%',height: '60%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          this.loadleads(0,this.perpage);
      });
  }

  openPreAuthDialog (lead_id) 
  {
      const dialogRef = this.dialog.open(UpdatePreauthModalComponent, {
          width: '50%',height: '70%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  clearCell(event){
    const alldata= this.hotRegisterer.getInstance(this.id);
  }

  exportLeadPartnerData()
    {
        if(this.leads.length>0)
        {
            let data = [];
            
            let titles = [
                'Patient Id',
                'Glamyo Patient Id',
                'Lead Data Time',
                'Lead Mobile',
                'Lead Name',
                'City Name',
                'Circle Name',
                'Lead Owner Name',
                'Description',
                'Insurance Owner Name',
                'Insurance Owner Description',
                'Treatment',
                'Payment Mode',
                'Status',
                'App Link Send Status',
            ];
            data.push(titles);
            for(let key in this.leads)
            {
                let exdata = [
                    this.leads[key].patient_id,
                    this.leads[key].glamyo_patient_id,
                    this.leads[key].lead_time,
                    this.leads[key].mobile,
                    this.leads[key].lead_name,
                    this.leads[key].city_name,
                    this.leads[key].circle_name,
                    this.leads[key].bd_name,
                    this.leads[key].description,
                    this.leads[key].insurance_bd_email,
                    this.leads[key].insurance_description,
                    this.leads[key].treatment_name,
                    this.leads[key].payment_mode,
                    this.leads[key].lead_status_name,
                    this.leads[key].is_appLink_sent
                ];
                data.push(exdata);
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'partner_lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    resetFilters(){
        this.clearDate();
        this.search = ''; this.lead_source = '';  this.lead_status = ''; this.bd = ''; this.link_share_filter='';
        this.loadleads(0,25);
    }

}

